import {NavLink} from "react-router-dom";
import SVG from "react-inlinesvg";
import React from "react";
import { useLocation } from "react-router";
import { toAbsoluteUrl, checkIsActive } from "../../../_metronic/_helpers";


export default function AppMenu({ layoutProps }){

    const location = useLocation();

    const getMenuItemActive = (url) => {
        return checkIsActive(location, url) ? "menu-item-active" : "";
    }

    return (
        <div
            id="kt_header_menu"
            className={`header-menu header-menu-mobile ${layoutProps.ktMenuClasses}`}
            {...layoutProps.headerMenuAttributes}
        >
            <ul className={`menu-nav ${layoutProps.ulClasses}`}>
                {/*begin::1 Level*/}
                <li className={`menu-item menu-item-rel ${getMenuItemActive('/dashboard')}`}>
                    <NavLink className="menu-link" to="/dashboard">
                        <span className="menu-text">Accueil</span>
                        {layoutProps.rootArrowEnabled && (<i className="menu-arrow" />)}
                    </NavLink>
                </li>
                {/*end::1 Level*/}

                {/*Classic submenu*/}
                {/*begin::1 Level*/}
                <li
                    data-menu-toggle={layoutProps.menuDesktopToggle}
                    aria-haspopup="true"
                    className={`menu-item menu-item-submenu menu-item-rel ${getMenuItemActive('fiches')}`}>
                    <NavLink className="menu-link menu-toggle" to="/fiches/create">
                        <span className="menu-text">Demandes</span>
                        <i className="menu-arrow"></i>
                    </NavLink>
                    <div className="menu-submenu menu-submenu-classic">
                        <ul className="menu-subnav">
                            {/*begin::2 Level*/}

                            {/*<li className={`menu-item ${getMenuItemActive('/fiches')}`}>*/}
                            {/*    <NavLink className="menu-link" to="/fiches">*/}
                            {/*        <span className="menu-text">Liste des demandes</span>*/}
                            {/*    </NavLink>*/}
                            {/*</li>*/}

                            <li className={`menu-item ${getMenuItemActive('/fiches')}`}>
                                <NavLink className="menu-link" to="/fiches/create">
                                    <span className="menu-text">Soumettre une nouvelle demande</span>
                                </NavLink>
                            </li>

                        </ul>
                    </div>
                </li>
                {/*end::1 Level*/}

                {/*Mega submenu*/}
                {/*begin::1 Level*/}



                {/*<li*/}
                {/*    className={`menu-item menu-item-submenu menu-item-rel ${getMenuItemActive('/react-bootstrap')}`}*/}
                {/*    data-menu-toggle={layoutProps.menuDesktopToggle}*/}
                {/*    aria-haspopup="true"*/}
                {/*>*/}
                {/*    <NavLink className="menu-link menu-toggle" to="/react-bootstrap">*/}
                {/*        <span className="menu-text">Statistiques</span>*/}
                {/*        <i className="menu-arrow"></i>*/}
                {/*    </NavLink>*/}
                {/*    <div className="menu-submenu menu-submenu-classic">*/}
                {/*        <ul className="menu-subnav">*/}
                {/*            /!*begin::2 Level*!/*/}

                {/*            <li className={`menu-item ${getMenuItemActive('/builder')}`}>*/}
                {/*                <NavLink className="menu-link" to="/builder">*/}
                {/*                    <span className="menu-text">Abonnements</span>*/}
                {/*                </NavLink>*/}
                {/*            </li>*/}

                {/*            <li className={`menu-item ${getMenuItemActive('/builder')}`}>*/}
                {/*                <NavLink className="menu-link" to="/builder">*/}
                {/*                    <span className="menu-text">Utilisateurs</span>*/}
                {/*                </NavLink>*/}
                {/*            </li>*/}

                {/*        </ul>*/}
                {/*    </div>*/}

                {/*</li>*/}




                {/*Classic submenu*/}
            </ul>
        </div>
    )
}